import { Lightbulb } from "lucide-react";

export const Tips = ({ tips, testid }) => (
  <div className="space-y-2 rounded-lg border border-primary/30 bg-primary/5 p-4" data-testid={testid}>
    <p className="flex items-center gap-1.5 font-mono-erp text-[11px] uppercase tracking-widest text-primary"><Lightbulb className="h-3.5 w-3.5" />Cosa ti consiglio</p>
    <ul className="space-y-1.5 text-sm">
      {tips.map((t) => <li key={t} className="flex gap-2"><span className="text-primary">•</span><span>{t}</span></li>)}
    </ul>
  </div>
);

export const Stat = ({ label, value, testid }) => (
  <div className="rounded-lg border border-border/60 p-3" data-testid={testid}>
    <p className="font-mono-erp text-[10px] uppercase tracking-widest text-muted-foreground">{label}</p>
    <p className="mt-1 font-display text-xl font-bold">{value}</p>
  </div>
);
